import { render, staticRenderFns } from "./CampusGradeImport.vue?vue&type=template&id=50447c15"
import script from "../../controllers/campus_grade/campus-grade-import.js?vue&type=script&lang=js&external"
export * from "../../controllers/campus_grade/campus-grade-import.js?vue&type=script&lang=js&external"
import style0 from "./CampusGradeImport.vue?vue&type=style&index=0&id=50447c15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports